<script lang="ts">
  import { onMount, createEventDispatcher } from "svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { activityDtoFields } from "../../utils/TableFields/activity-dto.fields";
  import { PermissionService } from "../../utils/misc/permission-utils";
  import { user } from "../../app.store";

  $: tableFields = [...activityDtoFields, ...$tableCustomFields];

  let cancreate : boolean = PermissionService.isAllowedTo($user, 'activities.cancreate');
  let candelete : boolean = PermissionService.isAllowedTo($user, 'activities.candelete');
  let canedit : boolean = PermissionService.isAllowedTo($user, 'activities.canedit');
 
  export let entityId: number;
  export let entityTpe: string;

  import {
    filter,
    loading,
    records,
    pagination,
    initList,
    onCreate,
    onEdit,
    onDelete,
    onPageChange,
    search,
    clearSearch,
    tableCustomFields,
  } from "./activity.store";
import FormField from "../../components/Form/FormField.svelte";
import Switch from "../../components/Form/Fields/Switch.svelte";
import Icon from "../../components/Icon.svelte";
import Button from "../../components/Button.svelte";
import BaseLayout from "../../layout/BaseLayout.svelte";
import type { IActivityDTO } from "../../services/DTO";
import Tab from "../../components/Tab/Tab.svelte";

const dispatch = createEventDispatcher();

let filter_mine = 0;

function onMineToggle(ev)
{
  if (ev == 1)
  {
    $filter.criteria.assignedUserId = $user.oid;
    $filter.criteria.creatorUserId = $user.oid;
  }  
  else
  {
    $filter.criteria.assignedUserId = null;
    $filter.criteria.creatorUserId = null;
  }
  search();
}

function onInnerCreate(){
  if (entityId != null)
    dispatch("create", {   }); 
  else
    onCreate();
}

function onInnerEdit(actdto: IActivityDTO){
  if (entityId != null)
    dispatch("edit", {activity: actdto}); 
  else
    onEdit(actdto);
}

  onMount(() => {
    initList(entityId, entityTpe);
    if (entityId != null)
    {
      let tf = [];      
      tableFields.forEach(x => {
        if (x.name != 'per' && x.name != "type")
          tf.push(x);
      })
      tableFields = tf;
    }
  });

</script>

<div>
  <SearchHeader
    entitySingular={'task'}
    entityPlural={'task'}
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  >
  <div slot="search" class="level">
     
    <div class="level-item">
      <div>
         
        <FormField usageHelp="Solo miei">
          <Switch
            name=""
            condensed={true}
            altText="Mostra assegnati a me o create da me"
            bind:value={filter_mine}
            on:toggle={(ev) => onMineToggle(ev.detail)}
          />
        </FormField>
      </div>
    </div>
 
<!--
    <div class="level-item">
      <p class="control">
        <Button on:click={search}>
          <Icon name="search" />

          <span> Cerca </span>
        </Button>
      </p>
    </div>

    <div class="level-item">
      <p class="control">
        <Button on:click={clearSearch}>Azzera</Button>
      </p>
    </div> 
    -->
  </div>
  </SearchHeader>

  <Table
    loading={$loading}
    fields={tableFields}
    records={$records}
    pagination={$pagination}
    createEnabled={cancreate}
    editEnabled={false}
    showEnabled={true}
    deleteEnabled={candelete}
    on:create={(_) => onInnerCreate()}
    on:show={(e) => onInnerEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</div>
